export function isActor(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
//# sourceMappingURL=Actor.js.map